import { Collapse } from 'antd';
import cn from 'classnames';
import { ICategory } from 'utils/interfaces';

import styles from '../Faq.module.less';
import { Questions } from '../Questions';
import { getImage } from './utils';

const { Panel } = Collapse;

interface Props {
	data: ICategory[];
}

export const Categories = ({ data }: Props) => {
	return (
		<Collapse bordered={false} ghost expandIconPosition='right'>
			{data.map((category) => (
				<Panel
					key={category.descripcion}
					header={
						<div className={styles.panelHeader}>
							<div className={cn(styles.panelTitleCont, 'accordion-header')}>
								<img
									src={getImage(category.rutaIcono as any)}
									className={styles.panelImg}
									alt={category.descripcion}
								/>
								<p className={cn(styles.panelTitle, 'accordion-title')}>
									{category.descripcion}
								</p>
							</div>
						</div>
					}
				>
					<Questions questions={category.faqPreguntas} />
				</Panel>
			))}
		</Collapse>
	);
};
